import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';

import { branchShape } from '@bibliocommons/bc-prop-types';
import { WarningAlert } from '@bibliocommons/alerts';

import { Select, SelectOption, SelectDivider } from 'app/components/shared/Select';
import accountShape from 'app/shapes/accountShape';

import './PickupBranchSelect.scss';

export function PickupBranchSelect({
  currentAccount,
  branches,
  preferredBranches,
  handleChange,
  selectedBranchCode,
  intl
}) {
  function renderWarning() {
    const preferredBranchCodes = currentAccount.get('preferredLocations', Immutable.List());

    if (!selectedBranchCode && !preferredBranches.size && preferredBranchCodes.size > 0) {
      return (
        <WarningAlert>
          <FormattedMessage id="reselect_pickup_location_prompt" />
        </WarningAlert>
      );
    }

    return null;
  }

  function renderSelect() {
    const indexedPreferred = Immutable.Map(preferredBranches.map(branch => [branch.get('code'), branch]));
    const nonPreferredBranches = branches.filter(branch => !indexedPreferred.get(branch.get('code')));

    const renderOption = branch => (
      <SelectOption key={branch.get('code')} value={branch.get('code')}>
        {branch.get('name')}
      </SelectOption>
    );

    return (
      <Select
        id="place-hold-branch-select"
        dataKey="branch-select"
        name="branch"
        value={selectedBranchCode}
        handleChange={handleChange}
        prompt={intl.formatMessage({ id: 'form_label_select_a_branch' })}
      >
        {preferredBranches.map(renderOption)}
        {preferredBranches.size > 0 && <SelectDivider />}
        {nonPreferredBranches.map(renderOption)}
      </Select>
    );
  }

  if (branches.size > 0) {
    return (
      <div className="cp-pickup-branch-select">
        {renderWarning()}
        <label htmlFor="place-hold-branch-select">
          <FormattedMessage id="pick_up_at" />
        </label>
        {renderSelect()}
      </div>
    );
  }

  return null;
}

PickupBranchSelect.propTypes = {
  currentAccount: accountShape.isRequired,
  branches: ImmutablePropTypes.listOf(branchShape).isRequired,
  preferredBranches: ImmutablePropTypes.listOf(branchShape).isRequired,
  handleChange: PropTypes.func.isRequired,
  selectedBranchCode: PropTypes.string
};

export default injectIntl(PickupBranchSelect);
